<ng-container [formGroup]="scopeStageForm">
  <div class="card-body">
    <h2>Scopes</h2>
    <div class="form-row">
      <div class="form-group col-12">
        <label for="scopes" class="custom_label">Scopes *</label>
        <ng-select
          id="scopes"
          [items]="scopes"
          placeholder="Select Scopes"
          [closeOnSelect]="true"
          [multiple]="true"
          (remove)="onRemove($event)"
          formControlName="scopes"
          bindLabel="{{coreService.ngSelectBindLabel}}"
        >
        </ng-select>
        <app-validation-error [formGroup]="scopeStageForm" [controlName]="'scopes'"></app-validation-error>
      </div>
    </div>


    <div class="form-row">
      <div class="form-group col-12">
        <label for="stage_id" class="custom_label">Sales Stage *</label>
        <ng-select
          id="stage_id"
          [items]="stages"
          placeholder="Select Sales Stage"
          [closeOnSelect]="true"
          formControlName="stage_id"
          bindLabel="{{coreService.ngSelectBindLabel}}"
        >
        </ng-select>
        <app-validation-error [formGroup]="scopeStageForm" [controlName]="'stage_id'"></app-validation-error>
      </div>
    </div>


    <div class="form-row">
      <div class="form-group col-12">
        <label for="source_id" class="custom_label">Bid Type </label>
        <ng-select
          id="bid_types"
          [items]="bidTypes"
          placeholder="Select Bid Type"
          [closeOnSelect]="true"
          [multiple]="true"
          formControlName="bid_types"
          (keydown)="onKeyDown($event)"
          bindLabel="{{coreService.ngSelectBindLabel}}"
        >
        </ng-select>
        <app-validation-error [formGroup]="scopeStageForm" [controlName]="'bid_types'"></app-validation-error>
      </div>
    </div>

<!--    <div class="form-row">-->
<!--      <div class="form-group col-12">-->
<!--        <label  class="custom_label">Union Options </label>-->
<!--        <div class="row">-->
<!--          <div class="col-4 mb-2">-->
<!--            <mat-checkbox color="warn"  [formControlName]="'is_prevailing_wage'" (change)="onChangeUnionOptions($event)">Prevailing Wage</mat-checkbox>-->
<!--          </div>-->
<!--          <div class="col-4 mb-2">-->
<!--            <mat-checkbox color="warn" [formControlName]="'is_union'"  (change)="onChangeUnionOptions($event)">Union</mat-checkbox>-->
<!--          </div>-->
<!--          <div class="col-4 mb-2">-->
<!--            <mat-checkbox color="warn"  [formControlName]="'is_open_shop'"  (change)="onChangeUnionOptions($event)">Open shop</mat-checkbox>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->


    <div class="form-row">
      <div class="form-group col-12">
        <label for="source_id" class="custom_label">Source </label>
        <ng-select
          id="source_id"
          [items]="sources"
          placeholder="Select Source"
          [closeOnSelect]="true"
          (keydown)="onKeyDown($event)"
          formControlName="source_id"
          bindLabel="{{coreService.ngSelectBindLabel}}"
        >
        </ng-select>
        <app-validation-error [formGroup]="scopeStageForm" [controlName]="'source_id'"></app-validation-error>
      </div>
    </div>


    <div class="form-row">
      <div class="form-group col-12">
        <label for="probability" class="custom_label">Probability</label>
        <div class="input-box">
        <span class="prefix"><b>%</b></span>
        <input matInput currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', precision:'2',align:'left' }" id="probability" formControlName="probability" class="form-control" placeholder="Probability" name="probability">
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="description" class="custom_label">Description</label>
        <textarea id="description" class="form-control" formControlName="description" placeholder="Description" name="description"></textarea>
      </div>
    </div>

  </div>
</ng-container>
